import React from "react";
import Experience from "../home/Experience";
import Leadership from "../home/Leadership";
import Projects from "../home/ProjectsPreview";
import Banner from "../home/Banner";

const Home = () => {
  return (
    <div className="bg-background text-text">
      <Banner />
      <Experience />
      <Leadership />
      <Projects />
    </div>
  );
};

export default Home;
